import {SelectFieldOptionsType, SelectFieldValueType} from '../types'

export default function getStringValue(value: SelectFieldValueType, options: SelectFieldOptionsType = []): string {
    if (Array.isArray(value)) {
        const labels = options.filter(item => !!value.find(v => JSON.stringify(v) === JSON.stringify(item.value))).map(item => item.label)
        return labels.join(', ')
    }
    return options.find(item => JSON.stringify(item.value) === JSON.stringify(value))?.label || ''
}